import Timer from '../../analytics/timer';
/**
 * Manages beat scheduling with suspend/resume support
 */
export default class BeatScheduler {
    /**
     * Create a new beat scheduler
     * @param callback - Callback to invoke on each beat, receives diffTime
     * @param intervalMs - Beat interval in milliseconds
     */
    constructor(callback, intervalMs) {
        this.suspensionTime = 0;
        this.suspended = false;
        this.timer = new Timer(callback, intervalMs);
    }
    /**
     * Start the beat timer
     */
    start() {
        if (!this.suspended) {
            this.timer.start();
        }
    }
    /**
     * Stop the beat timer
     */
    stop() {
        this.timer.stop();
    }
    /**
     * Check if timer is currently running
     */
    get isRunning() {
        return this.timer.isRunning;
    }
    /**
     * Suspend the beat timer and return the elapsed time
     * @returns Elapsed time since timer started
     */
    suspend() {
        this.suspended = true;
        this.suspensionTime = new Date().getTime();
        const diffTime = this.timer.chrono.startTime ? this.suspensionTime - this.timer.chrono.startTime : 0;
        this.stop();
        return diffTime;
    }
    /**
     * Resume the beat timer
     * @param expireTimeMs - Session expiration timeout in milliseconds
     * @returns Object with shouldBeat flag and diffTime
     */
    resume(expireTimeMs) {
        this.suspended = false;
        const now = new Date().getTime();
        const diffTime = now - this.suspensionTime;
        const shouldBeat = diffTime < expireTimeMs;
        return { shouldBeat, diffTime };
    }
    /**
     * Check if currently suspended
     */
    isSuspended() {
        return this.suspended;
    }
    /**
     * Get the internal timer (for advanced use cases)
     */
    getTimer() {
        return this.timer;
    }
}
